// Copyright (c) Bentley Systems
import { useEffect, useState } from "react";
import { VariantVm } from "./variant-vm";
import { IconButton } from "@itwin/itwinui-react";

type VariantProps = {
  variant: VariantVm;
  clickFunction?: () => void;
};

const Variant = (variantProps: VariantProps) => {
  const [isActive, setIsActive] = useState<boolean>(
    variantProps.variant.isActive,
  );

  useEffect(() => {
    setIsActive(variantProps.variant.isActive);
  }, [variantProps.variant]);

  return (
    <IconButton
      styleType="borderless"
      isActive={isActive}
      label={variantProps.variant.label}
      onClick={() => {
        if (variantProps.clickFunction !== undefined) {
          variantProps.clickFunction();
        }
      }}
    >
      {variantProps.variant.label}
    </IconButton>
  );
};

export default Variant;
